export const makeIdHash = len => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < len; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export function capitalizeFirstCharEachWord(str: string): string {
  return str.split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('-');
}

/**
 * TinyMCE's HTML serializer emits soft hyphens as `&shy;` / `&#173;` even when the loaded
 * document used the raw U+00AD character (common in Word-sourced contract HTML). Normalize
 * before persisting so the payload is not littered with entity spellings the API did not send.
 */
export function normalizeTinyMceHtmlForPersistence(html: string): string {
  if (!html) return html;
  return html
    .replace(/&shy;/gi, '\u00AD')
    .replace(/&#0*173;/g, '\u00AD')
    .replace(/&#x0*ad;/gi, '\u00AD');
}